module.exports = __webpack_public_path__ + "img/第3章_3-1_孔廟謎題圖_疊圖1.jpg";